import { AddRounded, RemoveRounded } from "@mui/icons-material";
import { IconButton, SxProps, TextField, TextFieldProps } from "@mui/material";
import { memo, useCallback } from "react";
import { useStyles } from "./styles";

export type NumberInputFieldProps = {
    height?: number,
    stepSize?: number,
    minValue?: number,
    maxValue?: number,
    showSteppers?: boolean,
    onValueChange: (value: number) => void
} & TextFieldProps

const NumberInputField: React.FC<NumberInputFieldProps> = ({height, stepSize = 1, minValue, maxValue, showSteppers = true, sx, onValueChange, ...inputProps}) => {
    const { classes } = useStyles();
    let inputFieldProps = {...(inputProps || {})};

    const value = inputProps.value as number;
    let inputSxProps: SxProps = inputProps.sx || {
        textAlign: "center"
    };

    if (height) {
        inputSxProps = {
            ...inputSxProps,
            height: `${height}px`,
            padding: 0,
            lineHeight: `${height}px`
        }
    }

    if (showSteppers) {

        inputFieldProps = {
            ...inputFieldProps,
            InputProps: {
                ...(inputFieldProps.InputProps || {}),
                startAdornment: (
                    <IconButton
                        onClick={() => {
                            if (value === undefined) return
                            const newValue = value - stepSize
                            if (minValue !== undefined && newValue < minValue) return
                            onValueChange(newValue)
                        }}
                        size={'small'}
                        sx={{ p: 0.25 }}
                    >
                        <RemoveRounded fontSize="small" />
                    </IconButton>
                ),
                endAdornment: (
                    <IconButton
                        onClick={() => {
                            if (value === undefined) return
                            const newValue = value + stepSize
                            if (maxValue !== undefined && newValue > maxValue) return
                            onValueChange(newValue)
                        }}
                        size={'small'}
                        sx={{ p: 0.25 }}
                    >
                        <AddRounded fontSize="small" />
                    </IconButton>
                )
            }
        }
        }
    
    inputFieldProps.inputProps = {
        ...(inputFieldProps.inputProps || {}),
        sx: inputSxProps
    }

    const onChange = useCallback((event: React.ChangeEvent<HTMLInputElement>) => {
        const newValue = event.target.value;
        if (newValue === '' || isNaN(Number(newValue))) {
            onValueChange(0)
            return;
        }
        let numValue = Number(newValue);
        if (minValue !== undefined && numValue < minValue) {
            numValue = minValue
        }
        if (maxValue !== undefined && numValue > maxValue) {
            numValue = maxValue
        }
        onValueChange(numValue)
    }, [onValueChange])

    const sxProps = {
        ...(sx || {}),
        paddingX: 0
    }
    return <TextField value={value} {...inputFieldProps} sx={sxProps} classes={{root: classes.inputRoot}} onChange={onChange} />;
}

export default memo(NumberInputField)